import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface TooltipButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  tooltip: string;
  placement?: "top" | "bottom" | "left" | "right";
}

const TooltipButton: React.FC<TooltipButtonProps> = ({
  tooltip,
  placement = "bottom",
  children,
  ...buttonProps
}) => (
  <OverlayTrigger placement={placement} overlay={<Tooltip>{tooltip}</Tooltip>}>
    <button {...buttonProps}>{children}</button>
  </OverlayTrigger>
);

export default TooltipButton;
